import API from "../api/API";

function getStaffServices(staffID) {
  return new Promise((resolve, reject) => {
    API.get(`personal/team-members/${staffID}/services`).then(resolve, reject);
  });
}

export default getStaffServices;
